import React, { useState, useCallback, useMemo } from "react";
import { MapContainer, TileLayer, useMap, useMapEvent, Rectangle } from "react-leaflet";
import { useEventHandlers } from '@react-leaflet/core'

const POSITION_CLASSES = {
	bottomleft: 'leaflet-bottom leaflet-left',
	bottomright: 'leaflet-bottom leaflet-right',
	topleft: 'leaflet-top leaflet-left',
	topright: 'leaflet-top leaflet-right',
}

const BOUNDS_STYLE = {
	weight: 1
}

function MinimapBounds({
	parentMap
}) {
	const minimap = useMap()

	// Clicking a point on the minimap sets the parent's map center
	const onClick = useCallback(
		(e) => {
			parentMap.setView(e.latlng, parentMap.getZoom())
		},
		[parentMap],
	)
	useMapEvent('click', onClick)

	// Keep track of bounds in state to trigger renders
	const [bounds, setBounds] = useState(parentMap.getBounds())
	const onChange = useCallback(() => {
		setBounds(parentMap.getBounds())
		// Update the minimap's view to match the parent map's center and zoom
		minimap.setView(parentMap.getCenter(), (parentMap.getZoom() > 16 ? 10 : parentMap.getZoom() > 13 ? 9 : parentMap.getZoom() > 10 ? 7 : 5), {
			animate: true,
		})
	}, [minimap, parentMap])

	// Listen to events on the parent map
	const handlers = useMemo(() => ({
		move: onChange,
		zoom: onChange
	}), [])
	useEventHandlers({
		instance: parentMap
	}, handlers)

	return <Rectangle bounds={bounds} pathOptions={BOUNDS_STYLE} />
}

function MinimapControl({
	position,
	zoom
}) {
	const parentMap = useMap()

	// Memoize the minimap so it's not affected by position changes
	const minimap = useMemo(
		() => (
			<MapContainer
				style={{ height: 150, width: 150 }}
				center={parentMap.getCenter()}
				zoom={5}
				dragging={false}
				doubleClickZoom={false}
				scrollWheelZoom={false}
				attributionControl={false}
				zoomControl={false}>
		  		<TileLayer url={process.env.REACT_APP_CUSTOM_CDN_URL ? process.env.REACT_APP_CUSTOM_CDN_URL+"/osm/{z}/{x}/{y}.png" : "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"} />
		  		<MinimapBounds parentMap={parentMap} />
			</MapContainer>
		),
		[],
	)

	const positionClass =
		(position && POSITION_CLASSES[position]) || POSITION_CLASSES.topright
	return (
		<div className={positionClass}>
			<div className="leaflet-control leaflet-bar">{minimap}</div>
	 	</div>
	)
}

export default React.memo(MinimapControl);